/**
 * Report-Definition für die Risiken-Liste.
 *
 * Übersetzt die geladene Risiken-Liste in ein {@link ReportDocument}. Spalten
 * spiegeln die Kern-Spalten der UI-Tabelle: Beschreibung, Risiko, Umgebung,
 * Schwere, Eintrittswahrscheinlichkeit, Strategie. Leere Zellen werden als '—'
 * dargestellt.
 */
import {
  buildDocument,
  tableBlock,
  type ReportBlock,
  type ReportDocument,
} from '../../../lib/pdf/reportModel';

export interface RisikoReportItem {
  beschreibung: string;
  risiko: string | null;
  umgebung: string | null;
  weight: number;
  assessment: number;
  strategie: string | null;
}

export interface RisikenReportInput {
  items: RisikoReportItem[];
}

function fmtNum(n: number | null | undefined): string {
  return n == null || !Number.isFinite(n) ? '—' : String(n);
}

export function buildRisikenReport(input: RisikenReportInput): ReportDocument {
  const block: ReportBlock =
    input.items.length > 0
      ? tableBlock(
          [
            { header: 'Beschreibung', weight: 2.4 },
            { header: 'Risiko', weight: 2 },
            { header: 'Umgebung', weight: 2 },
            { header: 'Schwere', weight: 1 },
            { header: 'Eintritt', weight: 1 },
            { header: 'Strategie', weight: 1.4 },
          ],
          input.items.map((r) => [
            r.beschreibung || '—',
            r.risiko || '—',
            r.umgebung || '—',
            fmtNum(r.weight),
            fmtNum(r.assessment),
            r.strategie || '—',
          ]),
        )!
      : { kind: 'note', value: 'Noch keine Risiken erfasst.' };

  return buildDocument([{ title: 'Risiken', blocks: [block] }]);
}
